import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var BadgeConfig = t.type({
  id: t.string,
  name: t.string,
  imageUrl: t.string,
  description: t.string
});
export var PointProgress = t.type({
  __typename: t.literal('PointProgress'),
  current: t.number,
  totalRequired: t.number
});
export var ChallengeProgress = t.type({
  __typename: t.literal('ChallengeProgress'),
  challenge: nullable(t.type({
    headline: t.string
  }))
});
export var EventProgress = t.type({
  __typename: t.literal('EventProgress'),
  current: t.number,
  totalRequired: t.number,
  eventType: t.type({
    name: t.string
  })
});
export var ChallengeTypeCompletionProgress = t.type({
  __typename: t.literal('ChallengeTypeCompletionProgress'),
  current: t.number,
  totalRequired: t.number,
  challengeType: nullable(t.type({
    name: t.string
  }))
});
export var AdvocacyProgress = t.type({
  __typename: t.literal('AdvocacyProgress'),
  current: t.number,
  totalRequired: t.number
});
export var BadgeProgress = t.union([PointProgress, ChallengeProgress, EventProgress, ChallengeTypeCompletionProgress, AdvocacyProgress], 'BadgeProgress');
export var BadgeProgression = t.type({
  badge: BadgeConfig,
  badgeProgress: nullable(BadgeProgress),
  earnedDate: nullable(t.string)
});